import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

// Public simulator requests bypass the authenticated client's refresh flow.
const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

/**
 * دریافت لیست پکیج‌های خرید گروهی (به تفکیک فروشنده و نام پکیج)
 */
export async function getPackagesForSimulator() {
    const { data, error } = await client.GET('/customer/basket-simulator/packages');
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت پکیج‌ها.'));
    }
    return data || [];
}

/**
 * شبیه‌سازی سبد خرید برای یک پکیج مشخص
 * @param {{ package_id: string }} payload
 */
export async function simulateBasket(payload) {
    const { data, error } = await client.POST('/customer/basket-simulator/simulate', {
        body: payload
    });
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در محاسبه سبد.'));
    }
    return data;
}

/**
 * افزودن پکیج به سبد خرید واقعی
 * @param {{ vendor_id: string, items: Array<{product_id: string, quantity: number}> }} payload
 */
export async function addPackageToCart(payload) {
    const { data, error } = await client.POST('/customer/basket-simulator/add-to-cart', {
        body: payload
    });
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در افزودن به سبد خرید.'));
    }
    return data;
}